export default __webpack_public_path__ + "6ef63dd06301afe068fee4b81f45d2bb.png";